import { useLocation } from "react-router";
import { PAGE_IMAGES, IMAGE_DIR } from "../controller/pageImages";

/**
 * The page's own branded card, rendered on the page rather than only in the
 * Open Graph tags.
 *
 * Google Images indexes pictures that appear in the page's HTML with alt text
 * and text around them; an image named only in a <meta> tag is picked up
 * unreliably at best. The same card the page unfurls with therefore sits above
 * the footer as a summary graphic, which is also the honest reason for it to be
 * there — it restates what the page is about in one line.
 *
 * Rendered once from Layout, so a new page gets a card by adding a row to
 * PAGE_IMAGES and nothing else. Routes without a card render nothing.
 */
const PageCard = () => {
  const { pathname } = useLocation();
  const key = pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
  const card = PAGE_IMAGES[key];
  if (!card) return null;

  const src = `${IMAGE_DIR}/${card.file}`;

  return (
    <section className="page-card" aria-label="Page summary">
      <div className="ea-wrap page-card-grid">
        <figure className="page-card-figure">
          <img
            src={src}
            alt={card.alt}
            width="1200"
            height="630"
            loading="lazy"
            decoding="async"
          />
        </figure>
        <div className="page-card-note">
          <span className="ea-eyebrow">In short</span>
          <p>{card.alt}.</p>
          <a className="ea-text-link" href={src} download>
            Download this card
          </a>
        </div>
      </div>
    </section>
  );
};

export default PageCard;
